(function() {
  'use strict';

  angular.module('app.sponsoredOrganization', []);
})();
